import React from "react";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/context/AuthContext";
import { ProfileMenu } from "@/components/ProfileMenu";
import { usePriceContext } from "@/context/PriceContext";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useWatchlist } from "@/context/WatchlistContext";
import { useLocation } from "react-router-dom";
import { Signal, SignalHigh, SignalLow } from "lucide-react";
import { Navigation } from "@/components/Navigation";

const Header: React.FC = () => {
  const isMobile = useIsMobile();
  const { user } = useAuth();
  const { isConnected, reconnectingStatus } = usePriceContext();
  const { activeView, setActiveView } = useWatchlist();
  const location = useLocation();
  
  // Only show Market/Favorites tabs on the root path
  const showSubTabs = location.pathname === "/";

  const handleTitleClick = () => {
    // If already on the home page, reset to market tab
    if (location.pathname === "/") {
      setActiveView("market");
    }
  };
  
  // Function to render the connection indicator with appropriate icon
  const renderConnectionIndicator = () => {
    if (isConnected) {
      return (
        <span title="Connected">
          <SignalHigh className="w-4 h-4 text-green-500" />
        </span>
      );
    } else if (reconnectingStatus) {
      return (
        <span title="Reconnecting...">
          <SignalLow className="w-4 h-4 text-amber-500 animate-pulse" />
        </span>
      );
    } else {
      return (
        <span title="Disconnected">
          <Signal className="w-4 h-4 text-red-500" />
        </span>
      );
    }
  };
  
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className={`container flex ${isMobile ? 'h-10' : 'h-14'} items-center justify-between`}>
        <div className="flex items-center gap-2">
          <h1 
            style={{ fontSize: '0.9rem' }} 
            className="font-semibold cursor-pointer" 
            onClick={handleTitleClick}
          >
            Market Watch
          </h1>
          
          {renderConnectionIndicator()}
          
         
          
          {/* Desktop Navigation */}
          {!isMobile && <div className="ml-6"><Navigation /></div>}
        </div>
        
        <div className="flex items-center gap-2">
          {user && (
            <>
              <span style={{ fontSize: '0.9rem' }} className="mr-2 hidden sm:inline-block">Welcome, {user.account.name}</span>
              <ProfileMenu />
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
